export default __webpack_public_path__ + "static/media/25l-act.8d5612c6.svg";